import React, {Component,PropTypes} from 'react'
import {Link,Redirect} from 'react-router'
import NavBar from '../components/NavBar'
//import firebase from '../config/database';
//import Config, { userDetails } from   '../config/app';
// Required for side-effects


//require("firebase/firestore");

class App extends Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    //Uncomment if you want to do a edirect
    this.props.router.push('/firestoreadmin/cliniques') //Path where you want user to be redirected initialy
  }
  render() {

/*

    var user = firebase.app.auth().currentUser;
    var name, email, photoUrl, uid, emailVerified;
    
    if (user != null) {
      name = user.displayName;
      email = user.email;
      photoUrl = user.photoURL;
      emailVerified = user.emailVerified;
      uid = user.uid;  // The user's ID, unique to the Firebase project. Do NOT use
                       // this value to authenticate with your backend server, if
                       // you have one. Use User.getToken() instead.
    }

   // Get the ID clinica 

   var database = firebase.app.firestore();
   var db = firebase.app.firestore();


   //if(isCollection){
       //COLLECTIONS - GET DOCUMENTS RELATED TO CLINIC
      


       

   database.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {
     
     Snapshot.forEach(function(doc2) {

       var usuari = doc2.data();

      // document.write("valor clinica:", usuari.clinica);

      

     
       db.collection("videos_disponibles").where("idclinica" , "==" ,usuari.clinica).get().then(function(querySnapshot) {
     
         querySnapshot.forEach(function(doc) {

          var val = doc.data();

           document.write("title clinica:", val.idclinica);

        });
      });
      });
   });


*/
    return (
      <div className="content">
        <NavBar></NavBar>

        Dashboard
        <br />
        Add your own content here, instructions etc...
      </div>
    )
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js